export default __webpack_public_path__ + "static/media/wedge~bjwvEpug.b244e3cd.svg";